// Preferred-microphone persistence (invariant I1: the device that passed the
// test is the device the interview records with). sessionStorage: same-tab
// only, survives the instructions → interview SPA navigation, gone on close.

const key = (interviewId) => `micPreferredDevice_${interviewId}`;

export const setPreferredMic = (interviewId, pref) => {
  try {
    sessionStorage.setItem(key(interviewId), JSON.stringify(pref));
  } catch (_) {}
};

export const getPreferredMic = (interviewId) => {
  try {
    return JSON.parse(sessionStorage.getItem(key(interviewId))) || null;
  } catch (_) {
    return null;
  }
};

// Exactly { audio: true } when nothing is persisted — byte-identical to the
// pre-P1 behavior. `ideal` (not exact): a stale id falls back to the default
// device instead of throwing OverconstrainedError.
export const getPreferredAudioConstraints = (interviewId) => {
  const pref = getPreferredMic(interviewId);
  return pref && pref.deviceId
    ? { audio: { deviceId: { ideal: pref.deviceId } } }
    : { audio: true };
};
